import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Table from "../../../components/Common/dataTable/index";
import { formatMoney } from "helpers/numberHelper";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";

interface FeesTypesTableProps {
  dataSource: any[];
  onEdit: (record: any) => void;
  onDelete: (record: any) => void;
}

const { confirm } = Modal;
const FeesTypesTable: React.FC<FeesTypesTableProps> = ({
  dataSource,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("name"),
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: t("frequency"),
      dataIndex: "frequency",
      key: "frequency",
      render: (frequency: string) =>
        frequency === "unique_payment" ? t("unique_payment") : t("monthly_payment"),
    },
    {
      title: t("pricing_type"),
      dataIndex: "pricingModel",
      key: "pricingModel",
      render: (pricingModel: string) =>
        pricingModel === "unique_payment" ? t("unique_payment") : t("level_based_payment"),
    },
    {
      title: t("amount"),
      dataIndex: "baseAmount",
      key: "baseAmount",
      render: (baseAmount: number, record: any) =>
        record.pricingModel === "level_based_payment" ? (
          <div>
            {record.feePricing?.map((item: any) => (
              <div key={item.classLevel.name}>{`${item.classLevel.name}: ${formatMoney(item.amount)}`}</div>
            ))}
          </div>
        ) : (
          `${formatMoney(baseAmount)}`
        ),
    },
    {
      title: t("actions"),
      key: "actions",
      render: (_: string, record: any) => {
        const actions: Action[] = [
          {
            label: t("edit"),
            icon: "ti ti-edit", 
            actionType: "link",
            onClick: () => onEdit(record),
          },
          {
            label: t("delete"),
            icon: "ti ti-trash",
            actionType: "link", 
            onClick: () => showDeleteConfirm(record.id),
          }
        ];
        return <ActionsDropdown actions={actions} />;
      },
    },
  ];

  const showDeleteConfirm = (id: string) => {
    confirm({
      title: t("are_you_sure_you_want_to_delete_this_fee_type?"),
      icon: <ExclamationCircleOutlined />,
      content: t("this_action_cannot_be_undone"),
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk: () => onDelete(id),
    });
  };  

  return (
    <div className="mt-4">
      <div className="table-responsive">
        <Table columns={columns} dataSource={dataSource} pagination={true} />
      </div>
    </div>
  );
};

export default FeesTypesTable;
